import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import { vars } from "../Variables";
import { Button } from "../Button";
import { Text } from "../Typography";
import { EditIcon } from "../Icons";

const { whiteColor } = vars;

type actionObject = {
  icon?: ReactNode;
  text?: string;
  click?: () => void;
};

interface ICard {
  children: ReactNode;
  background?: string;
  disableShadow?: boolean;
  px?: number;
  py?: number;
  boxShadow?: string;
  action?: actionObject;
  heading?: string;
  disableHeader?: boolean;
  disableAction?: boolean;
  sx?: Object;
  borderRadius?: number;
  onClick?: () => void;
  onCardClick?: () => void;
}

export const Card: React.FC<ICard> = ({
  children,
  background = whiteColor,
  disableShadow = false,
  px = 4,
  py = 3,
  borderRadius = 2,
  onClick,
  onCardClick,
  action = {
    icon: <EditIcon style={{ marginRight: 8 }} />,
    text: "Edit Details",
  },
  boxShadow = "0px 1.39706px 2.79412px rgba(0, 0, 0, 0.08)",
  heading = "Heading",
  disableHeader = false,
  disableAction = false,
  sx,
}) => {
  return (
    <Box
      component={"div"}
      sx={{
        borderRadius,
        py,
        px,
        background,
        boxShadow: !disableShadow ? boxShadow : "none",
        ...sx,
      }}
      onClick={onCardClick}
    >
      {!disableHeader && (
        <Box mb={2.5} display="flex" alignItems="center">
          <Text variant="h3">{heading}</Text>
          {!disableAction && (
            <Button sx={{ ml: "auto" }} variant="outlined" onClick={onClick}>
              {action?.icon}
              {action?.text}
            </Button>
          )}
        </Box>
      )}
      {children}
    </Box>
  );
};
